import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    bybitTitle: 'Bybit Wallet',
    cloverTitle: 'Clover Wallet',
    coin98Title: 'Coin98 Wallet',
    trustTitle: 'Trust Wallet',
  },
};
